/**
 * 印度语
 */
const lang = {
	lang: { //语言切换
		langlist: [{
			type: "Chinese",
			name: "चीनीName",
			langimg: "../assets/zg.png"
		},
		{
			type: "English",
			name: "अंग्रेजीName",
			langimg: "../assets/zg.png"
		},
		{
			type: "Traditional",
			name: "चीनी पारंपरिक",
			langimg: "../assets/zg.png"
		},
		{
			type: "Japanese",
			name: "जापानीName",
			langimg: "../assets/zg.png"
		},

		{
			type: "Vietnamese",
			name: "विएतनामीName",
			langimg: "../assets/zg.png"
		},
		{
			type: "Malay",
			name: "मलायName",
			langimg: "../assets/zg.png"
		},
		{
			type: "Hindi",
			name: "हिंदीName",
			langimg: "../assets/zg.png"
		},
		{
			type: "Thai",
			name: "थाई",
			langimg: "../assets/zg.png"
		},
		{
			type: "Russian",
			name: "रूसीName",
			langimg: "../assets/zg.png"
		},
		{
			type: "Indonesian",
			name: "इंडोनेशियाName",
			langimg: "../assets/zg.png"
		}
		],
		langtype: "Hindi",
		langimg: "../assets/zg.png"
	},

	tabbar: { //底部
		index: "घर पृष्ठ",
		activity: "सक्रिया",
		to_promote: "एक्सटेंशन",
		help: "मदद",
		my: "मेरा"
	},
	// 提示
	prompt: {
		verification: "सत्यापन कोड त्रुटि",
		account: "खाता संख्या 8-20 अंक, शुद्ध संख्या या अक्षर",
		password: "6 अक्षर + अक्षर या अक्षर संयोजन से बड़ा या बराबर है",
		two: "दो पासवर्ड अक्षम हैं",
		yizhi: 'पासवर्ड तथा खाता एक ही नहीं होता',
		successful: "लागइन सफल होता है",
		loginsuccessful: "लागइन सफल",
		null: "खाता पासवर्ड खाली नहीं हो सकता",
		Binding: "बाइन्डिंग सफल",
		buzhengque: 'पता प्रारूप गलत है',
		address: "कृपया पता भरें",
		Please_choose: "कृपया पहले एक वस्तु चुनें और बेट मात्रा भरें",
		Bet_type: "कृपया पहले बेट प्रकार चुनें",
		success: "बेट सफल",
		complete_password: "कृपया पूरा पासवर्ड भरें",
		copy_success: "क्लिपबोर्ड में नक़ल किया गया",
		copy_fail: "नकल असफल",
		Set_success: "सफलतापूर्वक सेट करें",
		Set_password: "कृपया एक 6- अंकीय पासवर्ड नियत करें, जो 'अक्षर, मेल खाता है तथा खाली स्थान नहीं ह'ै",
		update_success: "सफलतापूर्वक परिवर्धित",
		input_number: "कृपया मात्रा भरें",
		addressvalue: "कृपया वालेट पता चुनें",
	},
	head: { //头部
		luckyhash: "हैश बेट",
		address: "बाइन्ड वालेट पता",
		history: "इतिहास बेटिंग",
		help: "मदद",
		lotteryRecord: "लोटेरी रेकॉर्ड",
		notice: "संदेश सूची",
		question: "सामान्य समस्या",
		performance: "बदला",
		add_address: "वालेट जोड़ें",
		asset: "कूटशब्द",
		balance: "बैलेंस विवरण",
		exchangeRecord: "बदलें",
		forrecord: "रेकॉर्ड बदलें",
		language: "भाषा सेटिंग",
		update_assets_password: "एसेट पासवर्ड परिवर्धित करें",
		update_login_password: "लॉगइन पासवर्ड परिवर्धित करें",

		myteam: "मेरी टीम",
		recharge: "बैलेंस फिर चार्ज करें",
		setting: "सेटअप",
		transactiondetails: "रिकार्ड बेटिंग",
		transfer: "कमिशन स्थानान्तरण",
		user: "व्यक्तिगत केंद्र",
		userInfo: "व्यक्तिगत डाटा",
		withdrawal: "विचड्रावेल",
		commission: "कमिशियन प्रतिक्रिया",
		withdrawalRecord: "विचड्रावेल रेकॉर्ड",
		top_up: "रेकर्ड फिर चार्ज करें"
	},
	withdrawalRecord: {
		Select_month: "महीना चुनें",
		afterPrice: "balance",

	},
	withdrawal: {
		withdrawalrecord: "विचड्रावेल रेकॉर्ड",
		commission: "नकद योग्य संपत्ति",
		number: "स्थानान्तरण के लिए मात्रा",
		withdrawal_number: "हटाएँ",
		money_address: "वालेट पता",
		addressvalue: "कृपया वालेट पता चुनें",
		poundage: "सेवा चार्ज",
		immediately: "तुरंत छोड़ें",
		Warm_prompt: "वार्म टिप्प: कृपया सही वालेट पता भरें, अन्यथा आप पैसा को छोड़ नहीं सकते। जब वालेट पता भरा जाता है और बाइंड है, तो यह परिवर्तन नहीं किया जा सकता. यदि आपको संपा",
		input_password: 'कृपया एसेट पासवर्ड भरें',
		betting: "बेट",

	},
	userInfo: {
		Head_portrait: "व्यक्तिगत अवातार",
		account: "खाता संख्या",
		Choose_picture: "अवतार चुनें",
		cancel: "रद्द करें",
		determine: "निर्धारित करें"
	},
	user: {
		wallet_account: "वालेट खाता",
		balance: "बैलेंस विवरण",
		top_up: "फिर चार्ज करें",
		withdrawal: "विडडवालCity",
		my_wallet: "मेरा वालेट",
		add_wallet: "वालेट जोड़ें",
		look: "रेकॉर्ड देखें",
		look_all: "और देखें",
		Pack_up: "दूर रखें",
		For_record: "रेकॉर्ड बदलें",
		bettingRecord: "ट्रांसेक्शन विवरण",
		reward: "प्रकटान बदला",
		goCustomerLink: "ऑनलाइन सेवा",
		Commission_account: "कमिशन खाता",
		transfer: "स्थानान्तरण",
		number: "डाटा बेटिंग",
		transactiondetails: "विवरण देखें",
		day: "आज बेट करें",
		day_winning: "आज जीत",
		my_team: "मेरी टीम",
		about_we: "हमारे बारेमें",
		center: "मनपसंद सेवा केंद्र",
		setting: "सेटअप",
		delete: 'मिटाएँ',
		isDelete: "वालेट मिटाने के लिए यकीन करें"
	},
	transfer: {
		money: "कमिशियन बैलेंस",
		account_balance: "खाताbalance",
		number: "स्थानान्तरण के लिए मात्रा",
		select: "कृपया चुनें",
		Immediately_transfer: "तुरंत स्थानान्तरण",
		password: "कृपया एसेट पासवर्ड भरें",
		betting: "बेट",

	},
	transactiondetails: {
		type: "प्रकार",
		input_type: "कृपया प्रकार चुनें",
		date: "दिनांक",
		select_date: "कृपया एक तारीख चुनें",
		select: "क्वेरी",
		bettingmoney: "बेट मात्रा",
		winning_amount: "जीते हुए मात्रा",
		time: "समय",
		not: "कोई डाटा नहीं",
		noopen: 'अभी नहीं खोलें',
		B1: 'शुक्ष हैश - शुक्ष आकार',
		B2: 'भाग्य हैश - भाग्य संयोजन',
		B3: 'Lucky hash - Lucky Dragon and tiger',
		B4: 'Lucky hash - Lucky villa leisure',
		B5: 'भाग्य हैश - भाग्य संख्या',
		A1: 'हाशी इंटरटेमेंट सिटी',
		A2: 'हाशी इंटरनेटेमेंट सिटी',
		A3: 'हाशी इंटरटेमेंट सिटी - लुकी घोर्स रेसिंग',
		A4: 'Hashi Entertainment City - Lucky size',
		A5: 'हाशी इंटरनेटेमेंट सिटी - भाग्य संयोजन',
		A6: 'हाशी इंटरटेमेंट सिटी',
		A7: 'हाशी इंटरटेमेंट सिटी',
		A8: 'हाशी इंटरनेटेमेंट सिटी - शुभ संख्या',

		options: [{
			value: "Comment-दो बाजू",
			label: "B1",
		},
		{
			value: "Comment-संयोजन",
			label: "B2",
		},
		{
			value: "Comment-ड्रैगन टाइगर संयोजन",
			label: "B3",
		},
		{
			value: "Comment-सौ परिवार खुशी",
			label: "B4",
		},
		{
			value: "Comment-एकल गैल",
			label: "B5",
		},
		],
	},
	setting: {
		phone: 'बाइन्ड मोबाइल संख्या',
		updatepwd: "लॉगइन पासवर्ड परिवर्धित करें",
		assets_pwd: "कूटशब्द",
		not: "सेट नहीं",
		yes: "सेट करें",
		language: "भाषा सेटिंग",
		exit: "हस्ताक्षर करें",

	},
	recharge: {
		recharge_code: "रेकर्ड फिर चार्ज करें",
		Chain_type: "चाइन प्रकार",
		address: "पता फिर चार्ज करें",
		copy_address: "पता कॉपी करें",
		remind: "कार्य याद रिमाइन्डर",
		content: "सामग्री सामग्री सामग्री सामग्री"
	},
	myteam: {
		select: "क्वेरी",
		time: "दिनांक",
		money: "दिन कमिशन",
		people: "सीधा उपनिर्देशिका की संख्या",
		team: "टीम",
		zsxx: "प्लेयर जानकारी देखने के लिए कृपया यूआईडी भरें",
		zsyj: 'सीधा प्रकार्य',
		tdyj: 'टीम कार्यान्वयनComment',
		jryj: 'आज के परिणाम',
		jrsy: 'आज की कमाई',
		ljsy: 'संचयी आय',
		friendsCategoryList: ['प्रथम श्रेणी मित्र', 'माध्यमिक मित्र', 'तीसरे स्तर का दोस्त', 'चौथी कक्षा का दोस्त', '5वें स्तर का दोस्त'],
	},
	announcement: {
		title: 'नवीनतम घोषणा',
		close: 'समापन',
	},
	login: {
		order_password: "पुराना पासवर्ड",
		input_ordpwd: "कृपया अपना पुराना पासवर्ड भरें",
		new_pwd: "नया पासवर्ड",
		number: "कृपया 6- 16 बड़े और छोटे अक्षर + संख्या सेट करें",
		six_pwd: "कृपया एक 6- अंकीय पासवर्ड भरें",
		confirmPassword: "पासवर्ड यकीन करें",
		confirm: "पुष्टि करें",
	},
	forrecord: {
		spending: "खर्च बदलें",
	},
	exchangeRecord: {
		exchangeRecord: "बदलें",
		record: "रिकार्ड",
		For_spending: "खर्च बदलें",
		money: "एक्सचेंज मात्रा",
		exchange_number: "एक्सचेंज मात्रा",
		number: "संख्या",
		market_price: "मार्केट मूल्य",
		Miners_fee: "माइनर का फी",
		input_money: "कृपया बदलाव मात्रा भरें",
		Get_the_amount: "प्राप्त मात्रा",
		Can_be: "उपलब्ध मात्रा",
		address: "वालेट पता",
		Immediatelychange: "अब फिर दिया",
		Warm_prompt: "सचेतक",
		details: "विवरण"
	},
	balance: {
		balance_of: "balance",
		data: "दिनांक",
		dataPickerRange: "कृपया चुनें",
		select: "क्वेरी",
		to: 'to'
	},
	asset: {
		password: "कृपया एक 6- अंकीय पासवर्ड नियत करें, जो 'अक्षर, मेल खाता है तथा खाली स्थान नहीं है'",
		confirm: "पुष्टि करें",
	},
	add_address: {
		money_address: "कृपया वालेट पता भरें (trc20)",
		save: "संरक्षण"
	},
	spread: {
		cumulative: "आपका कुमुलेटिव आमन्त्रणा",
		people: "लोग",
		make: "कार्नेड",
		Continue_to: "बड़ा प्रतिज्ञा के लिए प्रयास करने के लिए जारी रखें",
		url: "लिंक साझा करें",
		Friends_registered: "मित्र रिजिस्टेशन",
		money: "वालेट लिंक करें",
		Friends_deal: "मित्र ट्रांसेक्शन",
		copy_url: "लिंक आमन्त्रणा कॉपी करें",
		my_group: "मेरी टीम",
		look: "प्रगति विवरण देखें",
		directCount: "सीधा उपनिर्देशिका की संख्या",
		group: "टीम की संख्या",
		Commission_withdrawal: "कमिशियन प्रतिक्रिया",
		historyAward: "इतिहासिक कमिसियन प्राप्त",
		yesterdayAward: "कमिशियन कल",
		currentAward: "वर्तमान कमिशन प्राप्त",
		todayAward: "आज की प्रकार",
		my_invite: "मेरा निमन्त्रण कोड",
		copy_invite: "निमन्त्रण कोड कॉपी करें",
		top_title: "मेरा अधिकारी",
		update: "मूल बान्ड होने के बाद यह परिवर्तन नहीं किया जा सकता है",
		nikname: "बाइंड करने के लिए पैरेन्टर उपनाम भरें",
		binding: "बाइंडिंग",
		Commission_ratio: "कमिशन दर",
		level: "स्तर",
		ratio: "पुनः प्रारंभ करें (बेटिंग मात्रा)",
		Directly_under: "सीधा उपक्रम",
		first: "पहला",
		levelone: "स्तर",

	},
	performance: {
		datatime: "दिनांक",
		pick: "कृपया चुनें",
		select: "क्वेरी",
		total: "कुल प्रकार आज",
		performance: "कार्यान्वयन विवरण",
		directCount: "सीधे खेलाड़ी की संख्या",
		todayTotalPerformByDirect: "आज सीधे खेलाड़ी की कार्यान्वयन",
		other: "अन्य खेलाड़ी की संख्या",
		todayTotalPerformByOther: "अन्य खेलाड़ी की कार्यान्वयन",
		Commission_withdrawal: "कमिशियन प्रतिक्रिया",
		historyAward: "इतिहासिक कमिसियन प्राप्त",
		yesterdayAward: "कमिशियन कल",
		currentAward: "वर्तमान कमिशन प्राप्त",
		todayAward: "आज की प्रकार",
		Commission_ratio: "कमिशन दर",
		level: "स्तर",
		ratio: "पुनः प्रारंभ करें (बेटिंग मात्रा)",
		Directly_under: "सीधा उपक्रम",
		first: "पहला",
		levelone: "स्तर",
	},
	lotteryRecord: { //开奖记录
		block: "ब्लॉक",
		highly: "ब्लॉक उचाइ",
		results_of: "परिणाम",

	},
	help: {
		DAPP: "डेपीपी खेल चरण",
		a: "डीपीपी खेल पता की नकल करेंdt- trc20 स्थानान्तरण के लिए",
		b: "इस वेबसाइट को वालेट ब्लॉकचैन ब्राउज़र में खोलें (TRX नेटवर्क), आप तुरंत्र DAPP पर प्रतिलिपि नहीं कर सकते हैं",
		Focus_on: "कृपया हमेशा अपने घर पृष्ठ को ताजा करने के लिए नया ट्रांसेक्शन पता प्राप्त करने के लिए ध्यान दें.",
		login: "ब्लॉक हैश मूल्य क्वेरी करने के लिए वेव क्षेत्र के आधिकारिक वेबसाइट में लगइन करें",
		hash: "आप वेव क्षेत्र के आधिकारिक वेबसाइट पर अपने ब्लॉक हैश मूल्य क्वेरी कर सकते हैं",
		you: "आप वेव क्षेत्र के आधिकारिक वेबसाइट को भेट सकते हैं",
		login_website: "वेव क्षेत्र के आधिकारिक वेबसाइट में लगइन करें",
		query: "अपने ब्लॉक हैश मूल्य क्वेरी करें",
		look: "शिक्षक देखने के लिए क्लिक करें",
		congratulations: "अभिनन्दन",
		winning: "यदि आप प्रतिज्ञा जीते हैं, तंत्र तुम्हारे पास प्रतिज्ञा 1 मिनिट में लौटा देगा",
		address: "यदि आप प्रतिज्ञा जीते हैं, तंत्र 1 मिनट में प्रतिज्ञा को अपने स्थानान्तरण पता में लौटाएगा",
		number: "डिजिटल मुद्रा बदलाव में हमको खरीद करेंdt and TRX",
		skip: "यदि आपका वालेट हमें पहले से ही dt और TRX है, तो आप इस चरण को छोड़ सकते हैं",
		Digital_currency: "डिजिटल मुद्रा बदलाव में हमारे लिये आओर TRX को खरीद करें, और फिर हमारे लिये आओर TRX को अपने [डिसेंट्रालाइज किया गया वालेट के लिये स्थानान्तरित करें।",
		platform: "प्लेटफ़ॉर्म",
		url: "वेबसाइट",
		tutorial: "कोर्स",
		vpn: "दोस्त संकेत: यदि आप टेलिग्राफ खोल नहीं सकते, तो आप परमेश्वर VPN का उपयोग कर सकते हैं",
		vpnurl: "जादू लैंप VPN वेबसाइट",
		whirlwind: "साइक्लोन त्वरक वेबसाइट",
		can_login: "आप लॉग इन कर सकते हैं",
		why: "XXXX क्यों चुनें",
		most_fair: "सबसे अच्छा",
		play: "कोई किटिंग नहीं, कोई ड्रॉपिंग नहीं, कोई इंटरफेरेंस नहीं",
		Publicly_available: "ब्लॉक हैश मूल्य अनियमित रूप से उत्पन्न है, परिणाम एकत्रित है, बदला नहीं जा सकता, और सार्वजनिक रूप से जाँचा जा सकता है",
		security: "सुरक्षित",
		no_money: "काम की राजधानी देखा जा सकता है. पैसा हराने के बारे में चिंता मत करो",
		Cannot: "मालिक के स्थानान्तरण रेकॉर्ड देखा जा सकता है और गलत प्रकाशित नहीं किया जा सकता",
		Visi_convenient: "सबसे उत्तम",
		Without_registration: "रेजिस्टर करने के लिए कोई जरूरत नहीं, फिर चार्ज करने की जरूरत नहीं, छोड़ने के लिए कोई जरूरत नहीं",
		questions: "सामान्य समस्या",
		one: "क्या है [ब्लॉक हैश मूल्य]（Block Hash）",
		dna: "ब्लॉक हैश मूल्य डाटा का एक टुक्का DNA है. हर ब्लॉक हैश मूल्य अद्वितिय, अनियमित और अब्रेक करने योग्य है.",
		lookintroduce: "बैडू एंक्लिकोलिपोर्ड हैश मूल्य देखने के लिए क्लिक करें。",
		what: "क्या ब्लॉक- चेन",
		Block_chain: "मूलभूत में, ब्लॉकचैन एक साझेदारी डाटाबेस है जिसमें डाटा या जानकारी भण्डार किया जाता है. इसके पास गोष्टियों के विशेषता है, पूरी प्रक्रिया में ट्रेस छोड़ देते हैं, अनुसार, खुलापन और पारदर्शिता, संग्रहित पालना और",
		wallet: "केंद्रित वालेट? डिसेंट्राइज़ेड वालेट? क्यों सेंट्रालाइज नहीं किया जा सकता है वालेट？",
		example: "उदाहरण के लिए, यदि आपका वालेट पता एक है और आप पता e को 10usdt में स्थानान्तरण करें, लेकिन आप क्वेरी करने के लिए ट्रांसेक्शन हैश मूल्य इस्तेमाल कर सकते हैं, आप सिर्फ सेवा प ऐसा ही नहीं जानता कि ये 10 usdts आप के द्वारा बाहर स्थानान्तरण किया जाता है, क्योंकि e सिर्फ देख सकता है कि यह खाता पुस्तिका पता B है जो 10 us इसी कारण केंद्रित वालेट ब्लॉक जूतों पर वास्तविक स्थानांतरण जानकारी क्वेरी नहीं कर सकता.",
		why_winning: "मैं एक पंक्ति में क्यों जीता हूँ या नहीं जीता",
		First: "सबसे पहले, यह एक छोटी संभाव्य घटना है जिसने पंक्ति में बहुत बार नहीं जीता है",
		small: "छोटी संभावना घटना का परिभाषा",
		second: "दूसरी तरह, जीते और जीते नहीं हैं अनियमित घटना हैं, और अनियमित घटनाओं की आवृत्ति स्थिर मूल्य पर स्थिर होगी. बिना पुनरावृत्ति के विषय में, प्रत्येक के लिए दिखाने की संभावना बराबर है। इस संभावना में, हर कोई सच्चा है। उसी समय, अनियमित घटनाओं बड़ी संख्याओं के व्यवस्था के अनुसार पालन करेंगे (जिस परीक्षा अपरिवर्तित रहता है, जिस परीक्षा बहुत सारी बार पुनरावृत्ति करेंगे, और अनियमित घटनाओं की आवृत्ति बड़ी स तो कृपया स्थानान्तरण करने के लिए जारी रखें. जैसे स्थानान्तरण फ्रीक्वेन्सी बढ़ती है, प्रतिज्ञा जीते हुए",
		whydelay: "यह क्यों लड़का जाता है",
		Click_to_view: "ब्लॉक- चैन के गति परिवेश देखने के लिए क्लिक करें： 《विश्वास है जो गणना है, धीमा है जो गणना है》",
		six: "पैसा स्थानान्तरण करने के बाद क्यों एक कुंजी है? फिर हमारा प्रकार विकल्प क्या है? मैं किस को चुनाना चाहिए?",
		global: " दुनिया के पास बहुत सार्वजनिक जानते हैं",
		click_look: "वैश्विक जीजी सार्वजनिक चैन देखने के लिए क्लिक करें",
		how: "जब मुद्रा स्थानान्तरण करते हैं, यदि मैं पता को स्थानान्तरण करता हूँ या गलत मुद्रा क़िस्म चुनें? मैं लौटा सकता हूँ?",
		For_instance: " उदाहरण के लिए, जब आप हमारे पास पैसा स्थानान्तरण करते हैं, आपको यूएसडी के नीचे trc20 चुनाना चाहिए, लेकिन यदि आप ओमीनी या usderc20 को अन्य प्रकार US",
		How_to_force: "यदि आप गलत मुद्रा स्थानान्तरण करते हैं तो क्या करना है देखने के लिए क्लिक करें？",
		Other_problems: "अन्य मुद्दा",
		callwe: "यदि आपके पास कोई प्रश्न है, कृपया हमें संपर्क करें",
		immediately: "अब बात करें",
		company: "कंपनी जानकारी",
		link: "लिंक",
		register: "डिजिटल मुद्रा डिसेंट्रेलाइज किया गया वालेट",
		Already_have: "यदि आपके पास पहले से एक वालेट है, तो आप इस चरण छोड़ सकते हैं",
		download: "डिजिटल मुद्रा डेसेंट्रालाइज किया गया वालेट डाउनलोड करें और रिजिस्टर करें",
		com_title: "डिजिटल मुद्रा वालेट संबंधित वेबसाइट ट्यूटोरियल नीचे है"
	},
	register: { //登录注册
		login_tips: "कृपया अपना लॉगइन पासवर्ड फिर सेट करें",
		address: "कृपया वालेट पता भरें",
		confirm: "पासवर्ड यकीन करें",
		confirmupdate: "परिवर्तन सुनिश्चित करें",
		toRegister: "रेजिस्टर जाएँ",
		agreement: "हस्ताक्षर करें तथा सहमत करें",
		user: "प्रयोक्ता स्वीकार",
		policy: "निजी नीति",
		welcome: "स्वागत है",
		login: "अपने खाते में लगइन करें",
		forget: "पासवर्ड भूलें",
		nowLogin: "[degrees] in [radians]",
		nologin: "अस्थायी रूप से लगइन नहीं करें",
		new: "नवीन खाता बनाएँ",
		login: "अपने लागइन खाता के रूप में",
		account: "खाता संख्या 8-20 अंक, शुद्ध संख्या या अक्षर",
		password: "6 अक्षर + अक्षर या अक्षर संयोजन से बड़ा या बराबर है",
		confirm_password: "पासवर्ड यकीन करें",
		inviteCode: "कृपया आमन्त्रण कोड भरें (वैकल्पिक)",
		verificationCode: "कृपया सत्यापन कोड भरें",
		toRegister: "रेजिस्टर",
		noaccount: "कोई खाता नहीं",
		toLogin: "लॉगइन जाएँ"
	},
	address: {
		warmprompt: "वार्म टिप्प: कृपया सही वालेट पता भरें, अन्यथा आप पैसा को छोड़ नहीं सकते। जब वालेट पता भरा जाता है और बाइंड है, तो यह परिवर्तन नहीं किया जा सकता. यदि आपको संपा",
		tips: "कृपया कम से कम एक वालेट पता बाइंड करें. जब आप अपना पासवर्ड भूल सकते हैं, आप इसे पुनः प्राप्त नहीं कर सकते हैं",
		TRC20: "इनपुट त्रुटियों से बचाने के लिए, कृपया कॉपी करें और लंबा दबाएँ यहाँ चिपकाने के लिए (trc20)",
		toBind: "अब बाइन्ड",
		noBind: "अस्थायी रूप से बाइंड नहीं करें",
	},
	luckyhash: { //幸运哈希
		walletName: 'वालेट लिंक करें',
		exchange: "बदलें",
		reward: "बदला",
		Customerservice: "ग्राहक सेवा",
		instructions: "स्पष्ट करें",
		luckyhash: "Comment",
		entertainment: "हाशी इंटरटेमेंट सिटीCity name",
		Doublesided: "दो बाजू",
		odds: "अक्षर",
		immediately: "अब बात करें",
		combination: "संयोजन",
		LongHuge: "ड्रैगन टाइगर संयोजन",
		baccarat: "बाकाराटCity name ",
		gallbladder: "एकल गैल",
		Hashracingcar: "हैश रेसिंग",
		Hashspeedboat: "हाशी स्पीडबोट",
		Hashracing: "हैश घोड़े दौड़ें",
		bothsides: "दो पार्श्व",
		problem: "सामान्य समस्या",
		all: "और देखें",
		friend: "सहयोगी साझेदारी"
	},
	history: {
		block: "ब्लॉक",
		type: "प्रकार",
		big: "बड़ाdictionary variant",
		highly: "ब्लॉक उचाइ",
		results_of: "परिणाम"
	},
	entertainment: {
		lastBlock: "पछिला ब्लॉक",
		resultValue: "लोटेरी परिणाम",
		currentblock: "वर्तमान ब्लॉक",
		nextBlock: "लोटेरी ब्लॉक",
		toLotteryRecord: "लोटेरी रेकॉर्ड",
		block: "ब्लॉक",
		money1: "पैसा की मात्रा",
		type: "प्रकार",
		all: "और देखें",
		both_sides: "दो पार्श्व",
		big: "बड़ाdictionary variant",
		small: "छोटा",
		single: "एकल",
		double: "दोहरा",
		daxiao: 'आकार',
		champion: "चम्पियोन",
		yajun: 'runner- up',
		he: 'और',
		champion_one_size: "चैम्पियन एकल आकार",
		crown: "गुआन्याहेCity name",
		andbig: "हेडा",
		andsmall: "और छोटा",
		andsingle: "हेदनEthiopian month 4 - LongName",
		anddouble: "और दोहरा",
		championtwo: "दो किनारों को चैम्पियोन",
		combination: "संयोजन",
		forlarge: "बड़ा क्रम",
		smallsingle: "छोटा क्रम",
		large_double: "डाशुवाङ्गCity",
		small_double: "Xiao Shuangchina. kgm",
		Long_Huge: "ड्रैगन टाइगर संयोजन",
		dragon: "लोनCity",
		tiger: "टिगर",
		us: "बन्द करें",
		baccarat: "बाकाराटCity",
		zhuang: "जुआनName",
		idle: "विशेषता",
		gallbladder: "एकल गैल",
		Atotalof: "सामान्य",
		note: "टिप्पणी",
		Check_the_details: "विवरण देखें",
		money: "वालेट",
		pause: "मशीन चयन",
		reset: "रिसेट करें",
		inputmoney: "कृपया मात्रा भरें",
		submit: "भेजें",
		password: "कृपया ट्रांसेक्शन पासवर्ड भरें",
		betting: "बेट",
		determine: "निर्धारित करें",
	},
	details: {
		block: "ब्लॉक",
		money: "पैसा की मात्रा",
		type: "प्रकार",
		resultValue: "लोटेरी परिणाम",
		all: "और देखें",
		address: "बेटिंग पता",
		toLotteryRecord: "लोटेरी रेकॉर्ड",
		money: "वालेट बेटिंग",
		copy: "बीटिंग पता कॉपी करें",
		ts: "कृपया बदलाव के पता का उपयोग नहीं करो, अन्यथा तुम्हें बदला नहीं मिलेगा",
		USDT: "कृपया वेव क्षेत्र usdt / TRX (trc20) को स्थानान्तरण करें",
		Betting_amount: "बेट मात्रा",
		inputmoney: "कृपया बेटिंग मात्रा भरें",
		confirm: "पुष्टि करें",
		cancel: "रद्द करें",
	},
	data: {
		noData: 'कोई डाटा नहीं',
		deleteSuc: 'सफलतापूर्वक मिटाएँ',
		iscon: 'पुष्टि करें?',
		fenpan: 'बन्द अवधि के दौरान कोई बेटिंग स्वीकार नहीं है',
		erweima: 'QR कोड सहेजें'
	},
	phone: {
		title: 'बाइन्ड मोबाइल संख्या',
		phone: 'सेल- फोन संख्या',
		input: 'कृपया बाइंड मोबाइल फोन संख्या भरें',
		code: 'परीक्षण कोड',
		inputcode: "कृपया सत्यापन कोड भरें",
		getCode: 'सत्यापन कोड प्राप्त करें',
		details: 'कृपया पहले क्षेत्र कोड और मोबाइल फोन संख्या में भरें',
		success: 'प्रमाणीकरण कोड सफलतापूर्वक भेजा गया',
		bsuccess: 'बाइन्डिंग सफल',
		jiaoyi: 'कृपया पासवर्ड पहले सेट करें',
		caozuo: "आपरेशन सफल",
		touxiang: "कृपया एक अवातार चुनें",
		buzu: 'माफ़ करें, आपका क्रेडिट कम चल रहा है',
		tuiguan: 'प्रोमोटियन केंद्र',
		qubie: 'ब्लॉक- चैन वालेट के बीच भिन्न देखने के लिए क्लिक करें',
		yhm: 'कृपया अपना उपयोक्ता नाम भरें',
		mm: 'कृपया अपना पासवर्ड भरें',
		xqgg: 'जाओ और पहले देखो',
		llwm: 'हमसे संपर्क',
		lj: 'Please connect your wallet first',
		dk: 'कृपया इसे वालेट अनुप्रयोग में खोलें',
		qd: 'हम आपके शामिल होने के लिए तत्पर हैं',
		yjmx: 'कमिसियन विवरण'
	},
	vip: {
		jl: "बदला",
		xrjl: 'नया आइमर प्रतिदान',
		ckgz: 'नियम देखें',
		zcsj: 'रेजिस्टरेशन डोपोसिट',
		qbsj: 'मोबाइल फोन तथा वालेट पता बाइन्ड करें',
		dlq: 'अनुरोधित',
		qwc: 'पूरा करने के लिए',
		ylq: 'प्राप्त',
		tgrw: 'प्रोमोटियन कार्य',
		rwjl: 'कार्य बदला',
		yq: 'निमन्त्रणा',
		ghy: 'Quality friends',
		lqcg: 'सफलतापूर्वक प्राप्त',
		bz: "Please enter the recharge currency",
		je: 'Please enter the recharge amount',
		xyb: 'next step',
		czpz: 'Please upload the recharge voucher',
		zzhx: 'Please enter transfer hash',
		ljtj: 'Submit now'

	}

}
export default lang



// WEBPACK FOOTER //
// ./src/i18n/language/Hindi.js